export default __webpack_public_path__ + "static/media/location-icon.8356a431.svg";